// extracted by mini-css-extract-plugin
export default {"botao":"botao_botao__6nq+t","botaoPequeno":"botao_botaoPequeno__xkwiV"};